import {MainVideoState} from "../definitions/MainVideoState";

export const startedLoadingGps = (state: MainVideoState) => {
    state.locationState.frameToGpsFast = new Map();
    state.locationState.nearestGps = undefined;
};
